import React from 'react';
import { MapPin, Clock, Tag } from 'lucide-react';

const formatDuration = (minutes) => {
  if (!minutes) return '—';
  const days = Math.round(minutes / (60 * 24));
  if (days < 1) return '< 1 day';
  return `${days} day${days > 1 ? 's' : ''}`;
};

const FamousSpots = ({ spots, imageBaseUrl }) => {
  if (!spots || spots.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted small mb-0">No famous spots available for this destination.</p>
      </div>
    );
  }

  return (
    <div className="pub-cus-des-famous-spots-container">
      <div className="row g-3">
        {spots.map((spot) => {
          const spotImg = spot.spot_image ? `${imageBaseUrl}/${spot.spot_image}` : null;

          return (
            <div key={spot.id} className="col-md-6">
              <div className="pub-cus-des-spot-card card border-0">
                {spotImg && (
                  <img
                    src={spotImg}
                    alt={spot.spot_title}
                    className="pub-cus-des-spot-img"
                    loading="lazy"
                    onError={(e) => { e.target.style.display = 'none'; }}
                  />
                )}

                <div className="card-body p-3">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <h6 className="fw-bold mb-0 pub-cus-des-spot-title">
                      {spot.spot_title}
                    </h6>
                    {spot.category && (
                      <span className="pub-cus-des-spot-cat-badge">
                        <Tag size={10} />
                        {spot.category}
                      </span>
                    )}
                  </div>

                  {spot.spot_description && (
                    <p className="text-muted pub-cus-des-spot-description mb-3">
                      {spot.spot_description}
                    </p>
                  )}

                  <div className="pub-cus-des-spot-meta">
                    {spot.latitude && spot.longitude && (
                      <div className="pub-cus-des-spot-meta-item">
                        <MapPin size={13} style={{ color: '#1B4965' }} />
                        <span className="text-muted small">
                          {parseFloat(spot.latitude).toFixed(4)}°, {parseFloat(spot.longitude).toFixed(4)}°
                        </span>
                      </div>
                    )}
                    <div className="pub-cus-des-spot-meta-item">
                      <Clock size={13} style={{ color: '#4A9E8E' }} />
                      <span className="text-muted small">
                        {formatDuration(spot.visit_duration)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FamousSpots;